import React, {useEffect, useRef, useState} from 'react'
import {connect} from "react-redux";
import action from "../../store/action";
import Option from "../Option";
import Scene from "../Scene";
import {Canvas} from "@react-three/fiber";
import JSZip from "jszip";
import {cloneDeep} from "lodash";
import WebDataTool from './Components/WebDataTool/index'
import ByteDataTool from "./Components/ByteDataTool";
import {message} from "antd";
import {useUpdateEffect} from "../../lib/customHooks";
import { useDispatch } from 'react-redux';
import {
    uploadPatientFileAdaption,
    uploadWebviewerPatientFileAdaption,
    getWebviewerModelAdaptionZip
} from '../../http/Adaption/apiAdapter'
import {getObjectByPatientsList, getPropertyByPatientsListObject} from "../../http/Adaption/queryData";
import {checkImageLink, getEncryptDataFromPath, getIsShareableLinkMode, getStageNumberFromFilePath, getStoragePhoto, getStorageXray} from "../../utils";
import { getMode } from '../../utils'
import { N8AO, EffectComposer } from '@react-three/postprocessing'
// import { BlendFunction } from 'postprocessing'
import { getOrderDetail } from '../../http/api/order';
import { photosDefaultList } from '../Option/Components/Photo';
import { setStageErrorModalVisible } from '../../store/action/webViewer';
import { ENV_CONSTANT, getEnv } from '../../config/env';
import { checkIsStageInvalid } from '../../common/webviwer-file';

import FileManager from '../../data/manager/dataMannger'
import StageManager from '../../data/manager/stageManager'
import { addPerform } from '../../tools/perform-tool';
/**
 * @description
 * Backup DataProcessing（./index_temp.js）
 *   New DataProcessing Changes
 *      1. Remove Simple Mock Data
 *      2. Remove useUpdateEffect
 *      3. Remove dataTool Relevance Judgment
 */

function DataProcessing(props) {

    const {
        currentPatient,
        stageCount,
        setLoadingData,
        setIsLoading,
        setCurrentClickItemId,
        currentDataTool,
        setCurrentPatient,
        setKeyframeNumber,
        isCombine,
        upperOrLower,
        buildTarget,
        setGridCheckboxValue,
        setOverlayCheckboxValue,
        setCollisionCheckboxValue,
        setIPRCheckboxValue,
        setAttachmentCheckboxValue,
        setCutoutsCheckboxValue,
        setPonticCheckboxValue,
        setBiteStopCheckboxValue,
        setPhotosList,
        setStageErrorModalVisible
    } = props

    const [sceneKey, setSceneKey] = useState(0);

    const dispatch = useDispatch();
    const [isUpdated, setIsUpdated] = useState(false)

    const [superimpositionMatrixList, setSuperimpositionMatrixList] = useState([])

    const [dentalData, setDentalData] = useState([])

    const [fileData, setFileData] = useState(new Map())

    const [mexicaliData, setMexicaliData] = useState([])

    const [smarteeOrByteData, setSmarteeOrByteData] = useState([])

    const [currentRequest, setCurrentRequest] = useState(1)

    const [requestEnd, setRequestEnd] = useState(false)

    const [patientsList, setPatientsList] = useState([])

    const [stageList, setStageList] = useState({})

    const [byteStageList, setByteStageList] = useState({})

    const isShareableLinkMode = getIsShareableLinkMode();

    const { advancedMode } = getMode()
    /**
     * @description    Synchronize the onload method
     * @param {Blob} blob
     * */
    const loadSync = (blob) => {
        return new Promise((resolve, reject)=> {
            // convert to base64
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            let raw = ''
            reader.onload = function () {
                // delete 'data:application/octet-stream;base64', Because it needs to be properly converted to buffer
                raw = reader.result.replace("data:application/octet-stream;base64,", '')
                resolve(raw)
            };
        })
    }


    /**
     * @description    Reading files
     * @param {Object} zip
     * */
    const readFiles = async (zip) => {
        const fileMap = new Map();
        for (let file in zip.files) {
            // console.log('>>>---', file)
            // In order to skip a folder. (file contains folders)
            if (!zip.files[file].dir) {
                await zip.file(file).async("arraybuffer")
                    .then(async content => {
                        let blob2 = new Blob([content])
                        if(sessionStorage.getItem('dataTool') === '1' || currentDataTool.key === 1) {
                            if (file.includes('info.json')) {
                                // console.log('>>>info.json', file)
                                let obj = await loadByteJson(blob2)
                                detectPattern(file, obj, fileMap)
                            } else if(file !== 'config.json'){
                                // console.log('>>>config.json', file)
                                let modelUrl = window.URL.createObjectURL(blob2)
                                detectPattern(file, modelUrl, fileMap)
                            }
                        }
                        else {
                            if (file.includes('.raw')) {
                                fileMap.set(file,  await loadSync(blob2))
                            } else {
                                let modelUrl = window.URL.createObjectURL(blob2)
                                fileMap.set(file, modelUrl)

                            }
                        }

                    })

            }
        }
        return fileMap
    }

    /**
     * @description    Create Stage Json Data
     * */
    const createStageInfoData = async (zip) => {
        let stage = {}
        const stageFolderContents = []
        // Get stage folder files name arr
        zip.forEach((relativePath, zipEntry) => {
            if(zipEntry.dir && relativePath.includes('STAGE')) {
                const fileNames = []
                zip.folder(relativePath).forEach((relativeFilePath, fileEntry) => {
                    fileNames.push(relativeFilePath)
                })
                stageFolderContents.push({
                    folder: relativePath,
                    fileNames: fileNames
                })
            }
        })
        stageFolderContents.forEach(item => {
          const { folder } = item
          let num = getStageNumberFromFilePath(folder)
          stage[`stage${num}`] = {
            upper: {
              visible: item.fileNames.some(name => name.includes('__UPPER__'))
            },
            lower: {
              visible: item.fileNames.some(name => name.includes('__LOWER__'))
            }
          }
        })
        return stage
    }

    const createPatientListData = (myMap) => {
        const filePath = myMap.keys().next().value
        debugger
        const { path, displayLabel } = getEncryptDataFromPath();
        const patientListData = [
          {
            fileName: filePath.split("/")[0],
            displayLabel,
            id: 0,
            uuid: path ? path.split("/").pop().split(".")[0] : "uuid",
          },
        ];
        setPatientsList(patientListData)
        if(sessionStorage.getItem('listItemId') !== null) {
            let params = {id: sessionStorage.getItem('listItemId')}
            const currentData = getObjectByPatientsList(params, patientListData);
            setCurrentPatient(currentData)
        }else {
            const currentData = patientListData[0]
            setCurrentPatient(currentData)
            let id = getPropertyByPatientsListObject('id', currentData)
            sessionStorage.setItem('listItemId', id)
        }
    }

    const setCurrentPatientData = (zip) => {
        
        let fileName = "--";
        try {
            fileName = Object.keys(zip.files)[0].split("/")[0];
        } catch (error) {
            fileName = "--";
        }

        const { path, displayLabel } = getEncryptDataFromPath();
        const currentPatient = {
            fileName: fileName,
            displayLabel,
            id: 0,
            uuid: path ? path.split("/").pop().split(".")[0] : "uuid",
        };
        setCurrentPatient(currentPatient)
    }

    const getPhotos = async () => {
        const { path, userId } = getEncryptDataFromPath()
        const orderId = path.split("/")[0]
        const res = await getOrderDetail({
            user_id: userId,
            order_id: orderId
        })
        const { data } = res
        const { patient_id } = data

        // get photos url
        
        const photosDefaultListClone = cloneDeep(photosDefaultList)

        const getImageUrl = async (item) => {
            const photoItem = cloneDeep(item)
            if(['panoramic', 'cephalometric'].includes(photoItem.key)) {
                const url = await getStorageXray({
                    user_id: userId,
                    patient_id: patient_id,
                    file_name: photoItem.key,
                })
                // const link = await checkImageLink(url)
                photoItem.src = url
            } else {
                const url = await getStoragePhoto({
                    user_id: userId,
                    patient_id: patient_id,
                    file_name: photoItem.key,
                })
                // const link = await checkImageLink(url)
                photoItem.src = url
            }
            return photoItem
        }

        const getImageUrlPromiseList = photosDefaultListClone.map(item => getImageUrl(item))
        const photosUrlList = await Promise.all(getImageUrlPromiseList)
        setPhotosList(photosUrlList)
    }

    const convertToStageList = (stageDOList) => {
        const stageList = {};
        for (const stageDO of stageDOList) {
            const { stageNumber } = stageDO;
            stageList[`stage${stageNumber}`] = {
                upper: {
                    visible: stageDO.upperVisible,
                    loaded: false
                },
                lower: {
                    visible: stageDO.lowerVisible,
                    loaded: false
                }
            };
        }
        return stageList;
    }
    /**
     * @description   get data from interface.
     *                1. Decompress the archive and convert it into a format based on its contents, such as stl files to URl and raw files to base64
     *                2. format data.
     *                3.Read data bitwise according to the functions defined by the dataConversion.
     * */

    const getData = async () => {
        setSceneKey((pre) => pre + 1)
        setIsLoading(true)
        let fileMap = new Map();
        let stageInfo = {}
        //set loading. when reload model, we need reset our redux param and component param
        await setCurrentClickItemId(null)
        await setIsUpdated(false)
        await setLoadingData(true)

        let modelData;

        if(buildTarget === "webviewer") {
            addPerform({ name: "file.download.start" });
            let result = await getWebviewerModelAdaptionZip()
            addPerform({ name: "file.download.end  " });
            if (result != null && result.data != null) modelData = result.data
        }

        if(buildTarget === "webviewer" && modelData == null) {
            setIsUpdated(false)
            setIsLoading(false)
            setCurrentRequest(4)
            return
        }

        try {
            if (advancedMode && !isShareableLinkMode) {
                addPerform({ name: "file.getPhotos.start" });
                await getPhotos()
                addPerform({ name: "file.getPhotos.end" });
            }
            // zip.js loads the file stream to generate the corresponding file
            let blob = new Blob([modelData])
            const zip = new JSZip();
            addPerform({ name: "file.loadFile.start" });
            await zip.loadAsync(blob)
            // stageInfo = await createStageInfoData(zip)

            addPerform({ name: "file.readFiles.start" });
            addPerform({ name: "file.readFiles.end" });
            addPerform({ name: "file.init.start" });
            await FileManager.init(zip);
            addPerform({ name: "file.init.end" });
            
            addPerform({ name: "file.loadModelByFirstStageNumber.start" });
            // await FileManager.loadModel();
            const stageDOList = StageManager.getStageList();
            const lastStageNumber = stageDOList[stageDOList.length - 1].stageNumber;
            const lastKeyframeNumber = lastStageNumber - 1;

            stageInfo = convertToStageList(stageDOList);
            setKeyframeNumber(lastKeyframeNumber)
            await FileManager.loadModelByFirstStageNumber(lastStageNumber);
            addPerform({ name: "file.loadModelByFirstStageNumber.end" });
            FileManager.lazyLoadModel({
                onStageLoaded: (stageDO) => {
                    const { stageNumber } = stageDO;
                    stageInfo[`stage${stageNumber}`].upper.loaded = true;
                    stageInfo[`stage${stageNumber}`].lower.loaded = true;
                    const item = structuredClone(stageInfo);
                    // const item = JSON.parse(JSON.stringify(stageInfo));
                    setStageList(item)
                }
            });

            // createPatientListData(fileMap)
            setCurrentPatientData(zip)
            setCurrentRequest(4)
        }
        catch (err) {
            setIsUpdated(false)
            setIsLoading(false)
            setCurrentRequest(4)
            
            debugger
        }

        setStageList(stageInfo)
        setIsUpdated(true)
        setIsLoading(false)
        // setFileData(fileMap)
    }

    /**
     * @description   load byte json
     * @param {Blob} blob
     * */
    const loadByteJson = (file) => {

        return new Promise((resolve, reject)=> {
            // convert to base64
            let reader = new FileReader();

            let jsonData = ''

            reader.onload = function (e) {
                // delete 'data:application/octet-stream;base64', Because it needs to be properly converted to buffer
                jsonData = JSON.parse(e.target.result)

                resolve(jsonData)
            };

            reader.readAsText(file);

        })
    }

    /**
     * @description    Reading byte files
     * @param {Object} zip
     * */


    const detectPattern = (str, value, data) => {
        if(currentPatient.mode === 0) {
            return formatMexicaliData(str, value, data)
        }else {
            return switchByteOrSmarteeDataType(str, value, data)
        }
    }

    const formatMexicaliData = (key, value, fileMap) => {


        const regex = /\d+/g
        const num = regex.exec(key.replace(currentPatient.fileName, '').replace(currentPatient.fileName, ''))[0]

        console.log(fileMap, num)
        if(fileMap.has('stage' + num)) {
            let resValue = fileMap.get('stage' + num)

            let upperOrLowerItem = resValue.get(key.includes('upper') ? 'upper' : 'lower')

            let keySplit = key.split('/')
            upperOrLowerItem.set(keySplit[keySplit.length - 1], value)


        }else {
            let resItem = new Map()

            if(key.includes('upper')) {
                let keySplit = key.split('/')

                resItem.set('upper', new Map().set(keySplit[keySplit.length - 1], value))
                resItem.set('lower', new Map())

            }else if(key.includes('lower')) {
                let keySplit = key.split('/')
                resItem.set('upper', new Map())
                resItem.set('lower', new Map().set(keySplit[keySplit.length - 1], value))
            }

            fileMap.set('stage' + num, resItem)

        }

    }

    const switchByteOrSmarteeDataType = (key, value, fileMap) => {
        fileMap.set(key,value)
    }


    const fetchData = async () => {
        await getData()
        setRequestEnd(true)
    }

    // click upload button
    const loadDataHandler = (file) => {
        const promises = file.map((item)=>{
            return new Promise(async (resolve,reject)=> {
                let params = new FormData();
                params.append('file', item);
                let code;
                console.log(buildTarget, 'buildTarget')
                if(buildTarget === "webviewer") {
                    code = await uploadWebviewerPatientFileAdaption(params, item.name)
                }
                else {
                    code = uploadPatientFileAdaption(params, item.name)
                }

                if(code == 200) {
                    resolve(true)
                }

            })
        })

        Promise.all(promises)
            .then(res=> {
                // window.alert("ooooooooooo")
                console.log(res)
                setTimeout(()=> {
                    // fetchPatientListData(4)
                }, 2000)

            })
            .catch(err=> {
                console.log(err)
            })
    }

    const handleDataChange = (newData) => {

        setDentalData(cloneDeep(newData))
    }

    const setDentalDataHandler = async (val) => {
        addPerform({ name: "file.setDentalData.start" });
        // await setDentalData(cloneDeep(val))
        addPerform({ name: "file.setDentalData.end" });
        setTimeout(()=> {
            setIsUpdated(true)
            setIsLoading(false)
        }, 0)
    }

    const setByteDataHandler = async (val) => {
        await setMexicaliData(val)
        setIsUpdated(true)
    }

    const setSmarteeOrByteDataHandler = async (val) => {
        await setSmarteeOrByteData(val)
        setIsUpdated(true)
    }

    const clickCombineOrSeparate = async () => {

        setIsUpdated(false)

        setCurrentRequest(2)
    }

    // click the patient list open button
    const loadModel = async () => {
        setIsLoading(true)
        setIsUpdated(false)
        setCurrentRequest(2)
    }

    /**
     * @description Layer - Enable 'Attachment' 'Pontic' 'Bite Stop' in Read-Only mode
     */
    const initLayer = () => {
        setGridCheckboxValue(false)
        setOverlayCheckboxValue(false)
        setCollisionCheckboxValue(false)
        setIPRCheckboxValue(false)
        setAttachmentCheckboxValue(true)
        setCutoutsCheckboxValue(false)
        setPonticCheckboxValue(true)
        setBiteStopCheckboxValue(true)
    }

    const checkFile = async () => {
        const env = getEnv()
        const { advancedMode } = getMode()
        if(env !== ENV_CONSTANT.CANDID && advancedMode) {
            const isStageInvalid = await checkIsStageInvalid();
            if (isStageInvalid) {
                setStageErrorModalVisible(true)
            }
        }
    }
    

    useEffect(async () => {
        setIsLoading(true)
    }, []);

    useEffect( () => {
        setFileData(new Map())
        checkFile()
        console.log(currentRequest, "currentRequest")
        fetchData()
    }, []);

    useEffect(() => {
        const { readOnlyMode } = getMode()
        if(readOnlyMode) {
            console.log('...Read-Only Mode, Init Layer')
            initLayer()
        }
    }, [])

    return (
        <>
            {/* Determine which component to use to format the data based on the file identifier */}
            {
                currentDataTool.key !== 1 && requestEnd ? (
                    <WebDataTool getDentalData={setDentalDataHandler} fileData={fileData} />
                ) : currentDataTool.key === 1 && requestEnd ? (
                    <ByteDataTool getByteData={setByteDataHandler} getSmarteeOrByteData={setSmarteeOrByteDataHandler} fileData={fileData} />
                ) : <></>
            }
            <Option
                isUpdated={isUpdated}
                dentalData={dentalData}
                clickCombineOrSeparate={clickCombineOrSeparate}
                setDentalData={handleDataChange}
                setPatientsList={setPatientsList}
                patientsList={patientsList}
                stageList={stageList}
                byteStageList={byteStageList}
                setCurrentRequest={setCurrentRequest}
                loadDataHandler={loadDataHandler}
                loadModel={loadModel}
                buildTarget={buildTarget}
            />
            {
                <Canvas key={sceneKey} style={{width: '100vw', height: '100dvh'}} className={'canvasStyle'} id={'display'} gl={{logarithmicDepthBuffer: true}} tabIndex={0}>
                    {
                        requestEnd ? (
                            <Scene
                                isUpdated={isUpdated}
                                mexicaliData={mexicaliData}
                                setMexicaliData={setMexicaliData}
                                smarteeOrByteData={smarteeOrByteData}
                                dentalData={cloneDeep(dentalData)}
                                superimpositionMatrixList={superimpositionMatrixList}
                                setDentalData={handleDataChange}
                            />
                        ) : <></>
                    }
                    <EffectComposer disableNormalPass multisampling={4}>
                        <N8AO aoRadius={20} aoSamples={64} denoiseSamples={16} denoiseRadius={8} distanceFalloff={0.2} intensity={8} screenSpaceRadius halfRes />
                    </EffectComposer>
                </Canvas>
            }
        </>
    );
}

const mapStateToProps = state => ({
    stageCount: state.webViewer.stageCount,
    currentClickItemId: state.webViewer.currentClickItemId,
    isMobile: state.webViewer.isMobile,
    currentPatient: state.webViewer.currentPatient,
    currentDataTool: state.dataTool.currentDataTool,
    isCombine: state.webViewer.isCombine,
    upperOrLower: state.dataTool.upperOrLower,
    photosList: state.webViewer.photosList
})

const mapDispatchToProps = dispatch => ({
    setLoadingData: val => dispatch(action.setLoadingData(val)),
    setIsLoading: val => dispatch(action.setIsLoading(val)),
    // Stage parameter
    setCurrentClickItemId: val => dispatch(action.setCurrentClickItemId(val)),
    setCurrentPatient: val => dispatch(action.setCurrentPatient(val)),
    setKeyframeNumber: val => dispatch(action.setKeyframeNumber(val)),
    setGridCheckboxValue: val => dispatch(action.setGridCheckboxValue(val)),
    setOverlayCheckboxValue: val => dispatch(action.setOverlayCheckboxValue(val)),
    setCollisionCheckboxValue: val => dispatch(action.setCollisionCheckboxValue(val)),
    setIPRCheckboxValue: val => dispatch(action.setIPRCheckboxValue(val)),
    setAttachmentCheckboxValue: val => dispatch(action.setAttachmentCheckboxValue(val)),
    setCutoutsCheckboxValue: val => dispatch(action.setCutoutsCheckboxValue(val)),
    setPonticCheckboxValue: val => dispatch(action.setPonticCheckboxValue(val)),
    setBiteStopCheckboxValue: val => dispatch(action.setBiteStopCheckboxValue(val)),
    setPhotosList: val => dispatch(action.setPhotosList(val)),
    setStageErrorModalVisible: val => dispatch(action.setStageErrorModalVisible(val))
})

export default connect(mapStateToProps, mapDispatchToProps)(DataProcessing)
